export default __webpack_public_path__ + "static/media/projectfeature2.dd044c1f.png";